export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/joshua-earlez-a9fea6a7060fa9d3328fb40557333dc2.jpg";